import NiceModal from "@ebay/nice-modal-react";
import { ReactComponent as AlbumIcon } from "assets/icons/album.svg";
import { useMemo } from "react";
import { File } from "types/types";
import { isImageUrl } from "utils/utils";
import ImagePreviewModal from "./modals/ImagePreviewModal";

const TransferImages = ({ files }: { files?: File[] }) => {
  const imageFiles = useMemo(
    () => files?.filter((f) => isImageUrl(f.upldfilename)),
    [files],
  );

  const othersFiles = useMemo(
    () => files?.filter((f) => !isImageUrl(f.upldfilename)),
    [files],
  );

  const onPreview = (file: File) => {
    NiceModal.show(ImagePreviewModal, {
      file,
      files: imageFiles,
      isTransfer: true,
    });
  };

  return (
    <div className="flex flex-col gap-[0.625rem]">
      {!!imageFiles?.length && (
        <ul className="hidden 1700:grid grid-cols-2 gap-[0.625rem]">
          {imageFiles.map((file) => (
            <li
              key={file.id}
              className="relative inline-flex aspect-[187/113] border border-secondary"
            >
              <div className="size-full absolute z-0 bg-gray flex items-center justify-center">
                <div className="inline-flex">
                  <AlbumIcon />
                </div>
              </div>
              <button
                className="relative size-full"
                type="button"
                onClick={() => onPreview(file)}
              >
                <img
                  className="size-full object-cover"
                  src={file.filepath}
                  alt={file.filename}
                  loading="lazy"
                />
              </button>
            </li>
          ))}
        </ul>
      )}
      {!!othersFiles?.length && (
        <ul className="hidden 1700:block text-primary underline font-medium">
          {othersFiles.map((file) => (
            <li key={file.id}>
              <a
                className="line-clamp-1 break-all"
                href={file.filepath}
                target="_blank noreferrer"
              >
                {file.upldfilename}
              </a>
            </li>
          ))}
        </ul>
      )}
      {!!files?.length && (
        <ul className="block 1700:hidden text-primary underline font-medium">
          {files.map((file) => (
            <li key={file.id}>
              {isImageUrl(file.upldfilename) ? (
                <button
                  type="button"
                  className="line-clamp-1 break-all"
                  onClick={() => onPreview(file)}
                >
                  {file.upldfilename}
                </button>
              ) : (
                <a
                  className="line-clamp-1 break-all"
                  href={file.filepath}
                  target="_blank noreferrer"
                >
                  {file.upldfilename}
                </a>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TransferImages;
